export function inNativeApp() {
  if (typeof window === 'undefined') return false;
  return Boolean((window as any).ReactNativeWebView);
}

export const inIOSApp = () => {
  return /iPad|iPhone/.test(navigator.userAgent);
};
